import React from "react";
import { CircularProgress } from "@sscs/ui";
import { LoginLayout } from "Components";
import { useLoginInfo } from "Hooks";
import OIDCLogin from "../../components/OIDCLogin/OIDCLogin";
import SAMLLogin from "../../components/SAMLLogin/SAMLLogin";
import LocalLogin from "../LocalLogin/LocalLogin";

const UserLogin = (): React.JSX.Element => {
  const { isInFlight, isSSOLogin, ssoInfo } = useLoginInfo();

  if (isInFlight) {
    return (
      <LoginLayout>
        <CircularProgress size="large" />
      </LoginLayout>
    );
  }

  if (isSSOLogin && ssoInfo?.sso_type === "sso-oidc") {
    return (
      <LoginLayout>
        <OIDCLogin ssoInfo={ssoInfo} />
      </LoginLayout>
    );
  }

  if (isSSOLogin && ssoInfo?.sso_type === "sso-saml") {
    return (
      <LoginLayout>
        <SAMLLogin ssoInfo={ssoInfo} />
      </LoginLayout>
    );
  }

  return (
    <LoginLayout>
      <LocalLogin />
    </LoginLayout>
  );
};

export default UserLogin;
